import React, { Component } from 'react'
import Button from '@mui/material/Button'
import Grid from '@mui/material/Grid'
import DimensionMemberSelector from '../DimensionMemberSelector'
import CreateMultiSegment from '../../overlays/CreateMultiSegment';

export default class NominalValue extends Component {
    //#region React Hooks
    constructor(props) {
        super(props);
        this.state = {
            "chartId": -1,
            "connectionId": -1,
            "allConnectionIds": [],
            "dataSource": "",
            "connectionName": "",
            "trend": {
                "name": "Nominal Value",
                "type": 0,
                "baseValue": null,
                "isBaseDisplayed": false,
                "useAllOthersCalculation": false,
                "treatNullAsZero": false,
                "slicers": [],
                "selectors": [],
                "active": true,
                "referenceOnly": false,
                "showSlicers": true,
                "userFormat": ""
            },
            "dimensions": [],
            "dialogs": [],
            "addedMultiSegmentSelections": [],
            "newMultiSegments": [],
            "globals": []
        };
    }
    componentDidMount() {
        let trend = { "slicers": [] }
        let chartId = -1
        let connectionId = -1
        let allConnectionIds = []
        let dataSource = ""
        let connectionName = ""
        let dimensions = []
        let dialogs = []
        let globals = []

        // Read in the props passed in from the parent
        if (this.props.chartId !== undefined) { chartId = this.props.chartId; }
        if (this.props.trend !== undefined) { trend = this.props.trend; }
        if (this.props.connectionId !== undefined) { connectionId = this.props.connectionId; }
        if (this.props.allConnectionIds !== undefined) { allConnectionIds = this.props.allConnectionIds; }
        if (this.props.dataSource !== undefined) { dataSource = this.props.dataSource; }
        if (this.props.connectionName !== undefined) { connectionName = this.props.connectionName; }
        if (this.props.dimensions !== undefined) { dimensions = this.props.dimensions; }
        if (this.props.globals !== undefined) { globals =  this.props.globals }

        // Set up dialog array
        trend.slicers.forEach((d, i) => {
            dialogs.push(false)
        });

        this.initLoad(this.props.trend, this.props.dimensions);
        this.setState({ trend, chartId, connectionId, allConnectionIds, dataSource, connectionName, dimensions, dialogs, globals });
    }
    componentDidUpdate(prevProps, prevState, snapshot) {
        let trend = { "slicers": [] }
        let chartId = -1
        let connectionId = -1
        let allConnectionIds = []
        let dataSource = ""
        let connectionName = ""
        let dimensions = []
        let dialogs = []
        let globals = []

        let previousSlicers = prevProps.trend.slicers;
        let newSlicers = this.props.trend.slicers;

        if (prevProps.chartId !== this.props.chartId) {
            // Read in the props passed in from the parent
            if (this.props.chartId !== undefined) { chartId = this.props.chartId; }
            if (this.props.trend !== undefined) { trend = this.props.trend; }
            if (this.props.connectionId !== undefined) { connectionId = this.props.connectionId; }
            if (this.props.allConnectionIds !== undefined) { allConnectionIds = this.props.allConnectionIds; }
            if (this.props.dataSource !== undefined) { dataSource = this.props.dataSource; }
            if (this.props.connectionName !== undefined) { connectionName = this.props.connectionName; }
            if (this.props.dimensions !== undefined) { dimensions = this.props.dimensions; }
            if (this.props.globals !== undefined) { globals =  this.props.globals }

            // Set up dialog array
            trend.slicers.forEach((d, i) => {
                dialogs.push(false)
            });

            this.initLoad(this.props.trend, this.props.dimensions)
            this.setState({ trend, chartId, connectionId, allConnectionIds, dataSource, connectionName, dimensions, dialogs, globals })
        } else if (previousSlicers.length !== newSlicers.length || this.props.editorUpdates !== prevProps.editorUpdates) {
            if (this.props.trend !== undefined) { trend = this.props.trend; }

            // Set up dialog array
            trend.slicers.forEach((d, i) => {
                dialogs.push(false)
            });

            this.initLoad(this.props.trend, this.props.dimensions);
            this.setState({ trend: this.props.trend, dialogs: dialogs });
        }
    }
    render() {
        return <div>
            <div style={{ textAlign: "left" }}>Additional Selections:</div>
            {this.renderSlicerGrid(this.state.trend, this.state.connectionId, this.state.allConnectionIds, this.state.dataSource, this.state.chartId, this.state.dialogs, this.state.addedMultiSegmentSelections, this.state.newMultiSegments, this.state.connectionName, this.state.globals)}
        </div>;
    }
    //#endregion

    //#region Render Methods
    renderSlicerGrid = (trend, connectionId, allConnectionIds, dataSource, chartId, dialogs, addedMultiSegmentSelections, newMultiSegments, connectionName, globals) => {
        let rtnArr = [];

        trend.slicers.forEach((slicer, index) => {
            let selectedItem = { "caption": "", "isSelected": true };
            let items = slicer.items;

            items.forEach(item => {
                if (item.isSelected) { selectedItem = item; }
            });

            rtnArr.push(
                <div key={`slicer-grid-${index}`} style={{"overflow":"hidden"}}>
                    <Grid container spacing={2} direction="row" alignItems="center">
                        <Grid item xs={2}>{slicer.dimensionAlias}</Grid>
                        <Grid item xs={4}>{selectedItem.caption}</Grid>
                        <Grid item xs={6}>
                            <DimensionMemberSelector
                                multiSelect={false}
                                chartId={chartId}
                                dimensionAlias={slicer.dimensionAlias}
                                connectionId={connectionId}
                                allConnectionIds={allConnectionIds}
                                dataSource={dataSource}
                                selections={slicer.items}
                                addedMultiSegmentSelections={this.separateDimensions(newMultiSegments, slicer.dimensionAlias)}
                                addedNumber={this.separateDimensions(newMultiSegments, slicer.dimensionAlias).length}
                                connectionName={connectionName}
                                globals={globals}
                                onSelectionChange={(selections, dimensionAlias) => this.updateSlicerData(selections, dimensionAlias)}
                            />
                        </Grid>
                    </Grid>
                    <div style={{ "display": (slicer.dimensionAlias === "Measures" ? "none" : "block") }}>
                        <Button size="small" variant="contained" color="secondary" onClick={() => {
                            dialogs[index] = true;
                            this.setState({ dialogs });
                        }}>
                            Add New Multi Segment
                        </Button>
                    </div>
                    <CreateMultiSegment
                        open={dialogs[index]}
                        dimensionName={slicer.dimensionAlias}
                        connectionId={connectionId}
                        allConnectionIds={allConnectionIds}
                        dataSource={dataSource}
                        connectionName={connectionName}
                        closeEvent={() => this.setAllDialogsToFalse()}
                        onNewMultiSegmentCreation={(segmentCombination) => {
                            addedMultiSegmentSelections.push(segmentCombination);
                            newMultiSegments.push({ "dimension": slicer.dimensionAlias, "combo": segmentCombination })
                            this.setAllDialogsToFalse();
                            this.setState({
                                "addedMultiSegmentSelections": addedMultiSegmentSelections,
                                "newMultiSegments": newMultiSegments
                            });
                        }}>
                    </CreateMultiSegment>
                </div>
            )
        });

        return rtnArr;
    };
    //#endregion

    //#region Data Handlers
    initLoad = (trend, dimensions) => {
        if (trend.slicers.length === 0) {
            trend.slicers = [];
            dimensions.forEach(d => {
                trend.slicers.push({
                    "dimensionAlias": d.alias,
                    "dimensionSystemName": d.systemName,
                    "typeOfDimension": d.typeOfDimension,
                    "prefix": "",
                    "suffix": "",
                    "items": [],
                    "attributes": []
                });
            });
        }
    };
    updateSlicerData = (selections, dimensionAlias) => {
        let trend = this.state.trend;

        trend.slicers.forEach(s => {
            if (s.dimensionAlias === dimensionAlias) {
                s.items = selections;
            }
        });

        if (this.props.onSelectionChange) { this.props.onSelectionChange(trend); }
        this.setState({ trend });
    };
    setAllDialogsToFalse = () => {
        let dialogs = this.state.dialogs;

        for (let i = 0; i < dialogs.length; i++) {
            dialogs[i] = false;
        }

        this.setState({ dialogs })
    };
    separateDimensions = (newMultiSegments, dimension) => {
        let rtnVal = []

        newMultiSegments.forEach(s => {
            if (s["dimension"] === dimension) {
                rtnVal.push(s["combo"])
            }
        })

        return rtnVal
    }
    //#endregion
}